<wiz-h-divider width="100%" height="100%" gap="0" padding="5px">
  <wiz-hgroup width="350px" height="100%">
    <multi-display #mdMain width="100%" height="100%" [config]="mainConfig">
      <wiz-hgroup target="icons">
       <wiz-icon #btnDelete [wizDisabled]="!mayDelete()" class="image-purple" [wizTooltip]="'$.common.delete.$'" (click)="askForDelete()" >delete</wiz-icon>
      </wiz-hgroup>

      <wiz-hgroup target="title" [verticalAlign]="'center'" class="add-btn" gap="10" padding="0 0 10px">
        <wiz-icon #btnCreate [wizTooltip]="'$.connect.add.$'"  tooltipPlacement="right" class="image-back-orange" (click)="askForAdd()" [wizDisabled]="cantCreate">add</wiz-icon>
        <wiz-label class="titleLabel" [wizLabel]="'$.connect.add.$'" [wizTextBehavior]="'truncate'" width="100%"></wiz-label>
      </wiz-hgroup>
    </multi-display>
  </wiz-hgroup>

  <wiz-group width="100%" minWidth="600px" height="100%" [wizDisabled]="cantUpdate">
    <!-- Groupe de présentation lorsque pas de sélection -->
    <wiz-vgroup #vgDemo [visible]=false height="100%" width="100%" gap="10" class="section-container-parent">
      <widget-renderer class="view-widget" [title]="'$.connect.title.$'" [description]="'$.connect.description.menu.$'">
      </widget-renderer>
    </wiz-vgroup>

    <!-- zone détail "vraie" -->
    <wiz-vgroup class="section-container-parent"
      #vgEdition
      wizValidationContainer
      width="100%"
      minWidth="600px"
      height="100%"
      gap="10"
      [visible]=false>
      <!-- entête d'édition -->
    <wiz-hgroup wizValidationContainer width="100%" class="section-container" padding="10px" gap="10">

      <wiz-vgroup wizValidationContainer width="640px">
        <wiz-hgroup wizValidationContainer>
          <wiz-text-input
            #tiCode
            class="upper-case-input"
            [wizPlaceholder]="'$.common.define.$'"
            [wizValidator]="uniqueCodeValidator()"
            [wizLabel]="'$.common.code.$'"
            width="160px"
            [wizShowErrors]="true"
            [wizMandatory]="true"
            [wizMaxChars]="20">
          </wiz-text-input>
          <wiz-translation-basic
          #trsLabel
          wizValidator
          [wizPlaceholder]="'$.common.define.$'"
          [wizLabel]="'$.common.label.$'"
          width="160px"
          [wizShowErrors]="true"
          [wizMandatory]="true"></wiz-translation-basic>

        </wiz-hgroup>

        <wiz-hgroup wizValidationContainer>
          <wiz-translation-basic
          #trsDesc
          [wizTranslationMode]="'textarea'"
          [maxTranslation]="6"
          [wizLabel]="'$.common.description.$'"
          width="315px"
          height="80px"></wiz-translation-basic>

          <wiz-hgroup>
            <wiz-spacer width="30px"></wiz-spacer>
            <wiz-vgroup gap="0" height="100%">
              <wiz-label [wizLabel]="'$.connect.icon.$'" class="componentLabel"></wiz-label>
              <wiz-image
                #uploadImg
                tabindex="0"
                height="50px"
                class="img-picker"
                [useHandCursor]="true"
                (click)="clickForUpload()"
                (keydown)="keydownForUpload($event)"
              ></wiz-image>
            </wiz-vgroup>
            <wiz-icon
              [visible]="hasImage()"
              style="cursor: pointer; font-size: 20px"
              (click)="clearImage()"
              [wizTooltip]="'$.common.delete.$'">delete</wiz-icon>
          </wiz-hgroup>

        </wiz-hgroup>
      </wiz-vgroup>


        <wiz-spacer width="100%"></wiz-spacer>
        <!-- boutons d'action -->
        <wiz-vgroup gap="0" height="100%" width="250px" horizontalAlign="center">
          <wiz-button
            #btnSave
            [wizIcon]="'arrow-right'"
            [wizLabel]="'$.common.save.modification.$'"
            [iconPlacement]="'right'"
            [wizDisabled]="disableSave()"
            (wizClick)="doMerge()"
          ></wiz-button>
          <wiz-button
            #btnCancel
            class="cancel-button"
            [wizIcon]="'arrow-left'"
            [wizLabel]="'$.common.cancel.modification.$'"
            [wizDisabled]="disableCancel()"
            (wizClick)="doCancel()"
          ></wiz-button>
        </wiz-vgroup>

    </wiz-hgroup>

    <wiz-hgroup #detailGP1 wizValidationContainer width="100%" gap="10">
      <wiz-text-input
      #tiProcessCode
      [wizPlaceholder]="'$.process.code.$'"
      wizValidator
      [wizLabel]="'$.process.code.$'"
      width="160px"
      [wizShowErrors]="true"
      [wizMandatory]="true"
      [wizMaxChars]="50"> </wiz-text-input>

      <wiz-dropdown #ddlProcessMode wizValidator width="120px"
      [wizDataProvider]="modeDS" [wizLabelField]="'trsLabel'" 
      [wizMandatory]="true"
      [wizLabel]="'$.process.mode.$'"></wiz-dropdown>

      <wiz-dropdown #ddResultAction wizValidator width="200px"
      [wizDataProvider]="resultActionDS" [wizLabelField]="'trsLabel'" 
      [wizMandatory]="true"
      [wizLabel]="'$.process.result.action.$'"></wiz-dropdown>

    </wiz-hgroup>

    <wiz-hgroup #detailGP wizValidationContainer width="100%" height="100%" gap="10">
      
      <wiz-text-area #taParameters
        [wizLabel]="'$.process.parameters.$'"
        [wizMaxChars]="1000"
        width="300px"
        height="300px">
      </wiz-text-area>
      
      <wiz-vgroup gap="10" width="300px">
        <wiz-checkbox #cbUseWarning  [wizLabel]="'$.process.warning.use.$'"></wiz-checkbox>

        <wiz-translation-basic
        #trsWarnTitle
        [wizLabel]="'$.process.warning.title.$'"
        width="100%"></wiz-translation-basic>

        <wiz-translation-basic
        #trsWarnDetail
        [wizTranslationMode]="'textarea'"
        [maxTranslation]="6"
        [wizLabel]="'$.process.warning.detail.$'"
        width="100%"
        height="100px"></wiz-translation-basic>
      </wiz-vgroup>

      <wiz-vgroup gap="10" width="300px">
        <wiz-translation-basic
        #trsResultError
        [wizLabel]="'$.process.result.error.$'"
        width="100%"></wiz-translation-basic>

        <wiz-translation-basic
        #trsResultSuccess
        [wizTranslationMode]="'textarea'"
        [maxTranslation]="6"
        [wizLabel]="'$.process.result.success.$'"
        width="100%"
        height="100px"></wiz-translation-basic>
      </wiz-vgroup>
    </wiz-hgroup>


    </wiz-vgroup>
  </wiz-group>
</wiz-h-divider>
